import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder,UntypedFormGroup,FormControl } from '@angular/forms';
import {ExamsService} from '../../exams.service';
import {AutotextService} from '../../autotext.service';
import { Subscription } from 'rxjs';
import { CommerrorService } from 'src/app/commerror.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { SignatureService } from 'src/app/signature.service';
import { LoginService } from 'src/app/login.service';
import { PatientsService } from 'src/app/patients.service';


@Component({
    selector: 'app-cardio-general',
    templateUrl: './cardio-general.component.html',
    styleUrls: ['./cardio-general.component.scss'],
    standalone: false
})
export class CardioGeneralComponent implements OnInit, OnDestroy {
  editorConfig: AngularEditorConfig = { editable: true, height: 'fit-contnet', toolbarHiddenButtons:[
    ['subscript','superscript','strikeThrough',],[
    'backgroundColor',
    'customClasses',
    'link',
    'unlink',
    'insertImage',
    'insertVideo',
    'removeFormat',
    'toggleEditorMode']
  ]};
  GenForm: UntypedFormGroup;
  lastMed:string;
  private subscriptions = new Subscription(); // Changed: Use single Subscription to manage all

  // Exam Signature:
  private examSignedSub: Subscription;

  constructor(
    private fb: UntypedFormBuilder,
    public es: ExamsService,
    public atS: AutotextService,
    public ce: CommerrorService,
    public signatureService: SignatureService,
    public ls: LoginService,
    private patService: PatientsService
  ) {
    this.GenForm = this.fb.group({
      MedicalHistory: [''],
      Purpose: [''],
      Risk:[''],
      ECG:[''],
      Medications:[''],
      Protocol:[''],
      HeartRate:  [''],
      Procedure:[''],
      Indication:[''],
      Quality:[''],
      bpSystolic:[''],
      bpDiastolic: [''],
      FollowUpExam:[''],
      Repeat1:[''],
      Repeat2:[''],
      ReferingDoc:[''],
      HMO:[''],
      ReferralNum: [''],
      RefererringDocID: [''],
      ReferringDocLicense: [''],
      ReferringClinicCode: [''],
      ReferringClinicName: [''],
      TechniciansComments:[''],
      ReferralRequest:[''],
      MechanicBreathing:[''],
      LungVolumes:[''],
      O2Saturation:[''],
      DiffusionTest:[''],
      BronchoDilatatorsReaction:[''],
      SummaryHtml:[''],
      ProcedureResult :[''],
      EffortTest:[''],
      MethacholineChallenge:[''],
      FreeText:[''],
      HMOExamCode:[''],
      examCode:[''],
      HMOExamName:['']
    });
    if(! this.es.isClosed){
      this.es.getLastHistory(true).subscribe((data)=>{
        this.lastMed = data['history'];
      },(err)=>{
        console.log(err);
      });
    }
  }

  ngOnInit() {
    this.es.fillForm(this.GenForm,"cardioGeneral",false,true,['HMO'],['ReferralNum','ReferingDoc','HMO','RefererringDocID','ReferringDocLicense','ReferringClinicCode','ReferringClinicName','HMOExamCode','examCode','HMOExamName']);

    // Load form whenever a new exam is loaded
    this.subscriptions.add(
      this.es.examLoaded$.subscribe(() => {
        this.es.fillForm(this.GenForm,"cardioGeneral",false,true,['HMO'],['ReferralNum','ReferingDoc','HMO','RefererringDocID','ReferringDocLicense','ReferringClinicCode','ReferringClinicName','examCode','HMOExamName','HMOExamCode']);
      })
    );
    
    this.subscriptions.add(
      this.es.formLoaded$.subscribe(() =>{
        if(this.es.patServ.getPat().HMO && !this.GenForm.get('HMO').value){
          this.GenForm.get('HMO').patchValue(this.es.patServ.getPat().HMO)
        }
        this.ce.isCardio = true;
      })
    );
    
    this.subscriptions.add(
      this.GenForm.get('HMO').valueChanges.subscribe((data) =>{
        if(data != this.es.patServ.getPat()['HMO'] && data !='-1'){
          this.ce.errorCardio('שים לב כי סימנת קופת חולים שונה מפרטי הלקוח. \n האם ברצונך להמשיך?', false);
        }else{
          if(this.GenForm.get('HMO').value) {
            this.es.saveVals('HMO', this.GenForm.get('HMO').value, false, 'cardioGeneral');
            // Save HMOExamCode and HMOExamName only if HMO is Macabi
            if(this.GenForm.get('HMO').value === 'Macabi') {
              if(this.GenForm.get('HMOExamCode')?.value) {
                this.es.saveVals('HMOExamCode', this.GenForm.get('HMOExamCode').value, false, 'cardioGeneral');
              }
              if(this.GenForm.get('HMOExamName')?.value) {
                this.es.saveVals('HMOExamName', this.GenForm.get('HMOExamName').value, false, 'cardioGeneral');
              }
            }
          }
        }
      })
    );
    
    this.subscriptions.add(
      this.ce.ecnext$.subscribe(() =>{
        if(this.GenForm.get('HMO').value) {
          this.es.saveVals('HMO', this.GenForm.get('HMO').value, false, 'cardioGeneral');
          // Save HMOExamCode and HMOExamName only if HMO is Macabi
          if(this.GenForm.get('HMO').value === 'Macabi') {
            if(this.GenForm.get('HMOExamCode')?.value) {
              this.es.saveVals('HMOExamCode', this.GenForm.get('HMOExamCode').value, false, 'cardioGeneral');
            }
            if(this.GenForm.get('HMOExamName')?.value) {
              this.es.saveVals('HMOExamName', this.GenForm.get('HMOExamName').value, false, 'cardioGeneral');
            }
          }
        }
      })
    );

    this.examSignedSub = this.es.examSigned$.subscribe((data) => {
      this.es.examObject = data;
      this.GenForm.disable({ emitEvent: false });
      this.signatureService.isExamSigned(this.es.examObject);
    });
  }

  addLastMed(){
    if(this.GenForm.get("MedicalHistory").value)
      this.GenForm.get("MedicalHistory").setValue(this.GenForm.get("MedicalHistory").value + this.lastMed);
    else
      this.GenForm.get("MedicalHistory").setValue(this.lastMed);
  }

  // AR-24 change 3: AI medical-history summary from the patient's answered questionnaire.
  aiSummaryLoading = false;
  getAiSummary(field: string) {
    if (this.aiSummaryLoading) return;
    this.aiSummaryLoading = true;
    this.es.getAiSummary(this.es.ExamType, this.patService.getPat()?.PID).subscribe(
      (res: any) => {
        this.aiSummaryLoading = false;
        if (res && res.summary) {
          const control = this.GenForm.get(field);
          const existing = (control.value || '').toString().trim();
          const previous = (res.previousSummary || '').toString().trim();
          // Replace only our own previously-pasted AI block (exact match), so a
          // doctor's hand-typed notes are never overwritten; otherwise append.
          if (previous && existing === previous) {
            control.setValue(res.summary);
          } else {
            control.setValue(existing ? existing + '\n\n' + res.summary : res.summary);
          }
        } else if (res && res.reason) {
          alert('Could not generate a summary (' + res.reason + ').');
        }
      },
      () => {
        this.aiSummaryLoading = false;
      }
    );
  }


  getPneumologyExamTypes() {
    if (this.ls.maccabiExams) {
      return this.ls.maccabiExams.map(exam => exam.exam_name);
    }
    return [];
  }

  getExamCodes(examName: string): string[] {
    if (!this.ls.maccabiExams) return [];
    const exam = this.ls.maccabiExams.find(e => e.exam_name === examName);
    return exam ? [exam.code] : [];
  }

  setExamName($event) {
    const selectedExamName = $event.target.value;
    
    if (!selectedExamName || selectedExamName === '') {
      this.GenForm.get('examCode')?.setValue(null);
      this.GenForm.get('HMOExamCode')?.setValue(null);
      return;
    }
    
    // Check if it's a pneumology exam with maccabiExams
    if (this.ls.maccabiExams &&
        (this.ls.hasPremission("Pneumology") || this.ls.hasPremission("Methacholine"))) {
      const codes = this.getExamCodes(selectedExamName);
      if (codes.length > 0) {
        const codesString = codes.join(',');
        this.GenForm.get('HMOExamCode')?.setValue(codesString);
        this.GenForm.get('examCode')?.setValue(codesString);
        // Save the codes to the exam
        this.es.saveVals('HMOExamCode', codesString, false, 'cardioGeneral');
        this.es.saveVals('examCode', codesString, false, 'cardioGeneral');
        return;
      }
    }
    
    // Handle Maccabi exams
    if (this.ls.maccabiExams) {
      const exam = this.ls.maccabiExams.find(e => e.exam_name === selectedExamName);
      if (exam) {
        this.GenForm.get('examCode')?.setValue(exam.code);
        this.GenForm.get('HMOExamCode')?.setValue(exam.code);
        // Save the code to the exam
        this.es.saveVals('HMOExamCode', exam.code, false, 'cardioGeneral');
        this.es.saveVals('examCode', exam.code, false, 'cardioGeneral');
      }
    }
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();

    if (this.examSignedSub) {
      this.examSignedSub.unsubscribe();
    }
  }
}
